import { combineReducers } from 'redux';
import pages from './pages';

const onboardingReducer = combineReducers({
    pages
})

export default onboardingReducer;